const refs = 'home'
export default [{
        path: '/',
        name: refs,
        component: () =>
            import ('@/views/' + refs + '/List.vue')
    },
    {
        path: '/90',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'break-his-distress' } }
        },
    },
    {
        path: '/84',
        redirect: () => {
            return { name: 'show-projects', params: { slug: `well-and-mosque-abdullah-saud-ta'ims` } }
        },
    },
    {
        path: '/72',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'mosque-suleiman-samai-al-anzi' } }
        },
    },
    {
        path: '/64',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'artesian-well-/-al-rahma' } }
        },
    },
    {
        path: '/62',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'artesian-well-saud-butcher-saad-al-shatri-' } }
        },
    },
    {
        path: '/63',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'artesian-well-/-saud-butcher-saad-al-shatri-2' } }
        },
    },
    {
        path: '/53',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'mosque-fattouh-badr-ramadan' } }
        },
    },
    {
        path: '/39',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'bail-for-mosque-imam:-noura-turki-al-mutairi' } }
        },
    },
    {
        path: '/88',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'mosque-and-well-hallouh-al-shahimeh-and-her-parents' } }
        },
    },
    {
        path: '/13',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'indiasurfacewell' } }
        },
    },
    {
        path: '/83',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'food-basket-' } }
        },
    },
    {
        path: '/44',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'family-guarantee-in-kuwait' } }
        },
    },
    {
        path: '/35',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'atonement-of-yameen' } }
        },
    },
    {
        path: '/65',
        redirect: () => {
            return { name: 'show-projects', params: { slug: '-cancer-treatment' } }
        },
    },
    {
        path: '/47',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'the-rotten-family' } }
        },
    },
    {
        path: '/73',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'widows-in-kuwait' } }
        },
    },
    {
        path: '/89',
        redirect: () => {
            return { name: 'show-projects', params: { slug: "ensuring-rings-of-quran" } }
        },
    },
    {
        path: '/27',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'building-mosque' } }
        },
    },
    {
        path: '/82',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'displaced-syrians' } }
        },
    },
    {
        path: '/11',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'water-in-yemen' } }
        },
    },
    {
        path: '/78',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'the-mother-of-orphans.' } }
        },
    },
    {
        path: '/70',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'the-warmth-of-winter-' } }
        },
    },
    {
        path: '/77',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'the-great-sahabi-abu-bakr-al,-siddiq' } }
        },
    },
    {
        path: '/68',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'dafaa-shetaa' } }
        },
    },
    {
        path: '/31',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'ensuring-an-orphan' } }
        },
    },
    {
        path: '/38',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'sponsorship-of-an-imam' } }
        },
    },
    {
        path: '/71',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'alkhayr-doors' } }
        },
    },
    {
        path: '/85',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'yemen-warmth' } }
        },
    },
    {
        path: '/74',
        redirect: () => {
            return { name: 'show-projects', params: { slug: 'rivers-of-alkhair' } }
        },
    },
]